<script lang="ts">
	//Stores
	import { user_settings } from 'src/stores/account/user';
	//Services
	import { postReq } from '../services/http';
	import { format } from '../services/i18n';
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Helpers
	import { capFirstChar } from '../helpers/utilities';
	import { requestEmailValidationCode } from '../helpers/email_verification_helpers';

	//Design system components
	import {
		Button,
		Input,
		Alert,
		Row,
		Col,
		toast,
		ButtonV2,
		AlertV2,
		Text,
		InputV2,
	} from '@Shelly/shelly-design-system';

	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let toastEmailValidationMessage = null;
	export let overrideMessage = null;
	export let inModal = false;

	export let request = false;
	export let requestIsSent = false;
	let securityCodeValue = '';

	$: alertHeading = capFirstChar(
		overrideMessage
			? overrideMessage
			: $format('alert_confirm_email', {
					default:
						'To verify your identity, please confirm your email. You can change this later in User Settings under Privacy section',
				}),
	);

	const dispatch = createEventDispatcher();

	// REQUEST CODE ----------------------------------------------------------------------

	export const handleRequestCode = async () => {
		requestIsSent = true;
		const isCodeRequested = await requestEmailValidationCode();
		if (isCodeRequested) {
			request = true;
		}
		requestIsSent = false;
	};
	// SEND CODE ----------------------------------------------------------------------
	const handleSendCode = async (code) => {
		const data = await postReq('/user/check_code', {
			code: code,
		});
		if (data.isok) {
			const res = await postReq('/user/set_mail_notifications_permissions', {
				permissions: 1,
			});
			if (res.isok) {
				user_settings.update((res) => {
					res.mail_notifications_permissions = 1;
					res.mail_validated = 1;
					return res;
				});
				request = false;
				toast.open({
					type: 'success',
					title: toastEmailValidationMessage
						? toastEmailValidationMessage
						: $format('validation_active_toast'),
				});
				dispatch('close');
			} else {
				toast.open({ type: 'danger', title: $format('setting_err_toast') });
			}
		} else if (data.errors) {
			// no_code: 'No code provided.'
			// code_mismach: "The code doesn\\'t match."
			toast.open({
				type: 'danger',
				title: $format(Object.keys(data.errors)[0]),
			});
		}
	};
</script>

<!-- Alert explaining the email confirmation process -->
{#if !$showNewLayout}
	<Alert heading={alertHeading} />
{:else}
	<AlertV2 heading={alertHeading} />
{/if}

<!-- Input and button to enter the security code after request for confirmation code -->
{#if request}
	<!-- DO NOT REMOVE COMMENT: Padding references -->
	{#if !$showNewLayout}
		<Row>
			<Col xs="12" md="3">
				<Input
					id="input-confirm-code"
					aria-labelledby="input-confirm-code"
					class={inModal ? 'mt-m' : 'mt-s'}
					icon="fas fa-envelope"
					label={capFirstChar(
						$format('placeholder_security_code', {
							default: 'validation code',
						}),
					)}
					bind:value={securityCodeValue}
					type={'text'}
					on:enter={() => handleSendCode(securityCodeValue)}
				/>
			</Col>
			<Col xs="12" md="3">
				{#if !$showNewLayout}
					<Button
						size="m"
						class="width-md-auto width-sm-full {inModal ? 'mt-m' : 'mt-s'}"
						on:click={() => handleSendCode(securityCodeValue)}
					>
						{$format('button_confirm_email')}
					</Button>
				{:else}
					<ButtonV2
						size="m"
						variant="primary"
						on:click={() => handleSendCode(securityCodeValue)}
					>
						{$format('button_confirm_email')}
					</ButtonV2>
				{/if}
			</Col>
		</Row>
	{:else}
		<Text styleType="body" class="mt-m mb-m">
			{capFirstChar(
				$format('placeholder_security_code', {
					default: 'validation code',
				}),
			)}
		</Text>
		<div class="d-flex align-items-center gap-s {inModal ? 'flex-direction-column' : ''}">
			<div class="width-full" style="max-width: 300px;">
				<InputV2
					id="input-confirm-code"
					aria-labelledby="input-confirm-code"
					size={inModal ? 'l' : 'm'}
					label={capFirstChar(
						$format('placeholder_security_code', {
							default: 'validation code',
						}),
					)}
					bind:value={securityCodeValue}
					type={'text'}
					on:enter={() => handleSendCode(securityCodeValue)}
				/>
			</div>
			<ButtonV2 size="m" variant="primary" on:click={() => handleSendCode(securityCodeValue)}>
				{$format('button_confirm_email')}
			</ButtonV2>
		</div>
	{/if}
{/if}

{#if !inModal}
	<div class="d-flex">
		{#if !$showNewLayout}
			<Button
				loading={requestIsSent}
				disabled={requestIsSent}
				size="m"
				class="width-md-auto width-sm-full mt-s"
				on:click={() => handleRequestCode()}
				>{$format('button_request_confirmation_code')}</Button
			>
		{:else}
			<ButtonV2
				class="width-md-auto width-sm-full mt-s"
				size="m"
				variant="primary"
				on:click={() => handleRequestCode()}
			>
				{$format('button_request_confirmation_code')}
			</ButtonV2>
		{/if}
	</div>
{/if}
